import React from 'react';

import {
  ConfirmationDialog,
  ConfirmationDialogVariant,
} from 'src/components/generic/ConfirmationDialog';

export type UploadAsLatestVersionChoice = 'asNewDocument' | 'asVersion';

interface UploadAsLatestVersionDialogProps {
  documentName: string;
  onChoose: (choice: UploadAsLatestVersionChoice, session: number) => void;
  open: boolean;
  session: number;
}

export const UploadAsLatestVersionDialog = React.memo(function UploadAsLatestVersionDialog({
  documentName,
  onChoose,
  open,
  session,
}: UploadAsLatestVersionDialogProps): JSX.Element {
  return (
    <ConfirmationDialog
      message={`Looks like this is already in Aline: ${documentName}`}
      open={open}
      primaryText="Upload as latest version"
      secondaryText="Upload as new document"
      title="Upload as latest version?"
      variant={ConfirmationDialogVariant.Info}
      onClickPrimary={() => onChoose('asVersion', session)}
      onClickSecondary={() => onChoose('asNewDocument', session)}
      onClose={() => onChoose('asNewDocument', session)}
    />
  );
});
